export const navAccount = [
  {
    title: "Account Information",
    href: "/my-account/"
  },
  {
    title: "Orders",
    href: "/my-account/orders/"
  },
] as const;
